import * as React from 'react';

interface IProps {
    loopTitle: string;
}

export class LoopEnd extends React.Component<IProps, any> {

    render() {

        let { loopTitle } = this.props;

        return <div className='component ui-only'>
            <div className="component-summary component-inner">
                <span>End of <strong>{loopTitle}</strong></span>
            </div>
        </div>;

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/loop/loop-end.tsx